import React from "react";
import "./Collage_portal_documents.css";
import { Col, Row } from "react-bootstrap";
import Documents_buckets from "./documents_buckets/Documents_buckets";
import Blue_border_button from "../../../../common_components/common_btn/blue_border_button/Blue_border_button";
import {
  faCircleCheck,
  faCircleInfo,
  faUpload,
} from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import Blue_btn from "../../../../common_components/common_btn/blue_btn/Blue_btn";
import Internship_Agreement_Card from "../../../../common_components/common-cards/internship-agreement-card/Internship_Agreement_Card";

function Collage_portal_documents() {
  const documentCardsData = [
    {
      name: "Priyank Sharma",
      id: "APP12546",
      email: "priyank2254@gmail.com",
      contact: "+91 7869875654",
      uploadedBy: "HR Department",
      uploadDate: "18/01/2026",
      documents: [
        { doc: "Travel Insurance", icon: faCircleCheck },
        { doc: "Motivation", icon: faCircleInfo },
        { doc: "Statement", icon: faCircleCheck },
        { doc: "CV", icon: faCircleInfo },
      ],
      note: "Prepare the intern's arrival",
      status: "Signed",
    },
    {
      name: "Rahul Verma",
      id: "APP12547",
      email: "rahul.verma@gmail.com",
      contact: "+91 9876543210",
      uploadedBy: "Admin Team",
      uploadDate: "20/01/2026",
      documents: [
        { doc: "Travel Insurance", icon: faCircleCheck },
        { doc: "Motivation", icon: faCircleInfo },
        { doc: "Statement", icon: faCircleCheck },
        { doc: "CV", icon: faCircleInfo },
      ],
      note: "Prepare the intern's arrival",
      status: "Pending",
    },
    {
      name: "Priyank Sharma",
      id: "APP12546",
      email: "priyank2254@gmail.com",
      contact: "+91 7869875654",
      uploadedBy: "HR Department",
      uploadDate: "18/01/2026",
      documents: [
        { doc: "Travel Insurance", icon: faCircleCheck },
        { doc: "Motivation", icon: faCircleInfo },
        { doc: "Statement", icon: faCircleCheck },
        { doc: "CV", icon: faCircleInfo },
      ],
      note: "Prepare the intern's arrival",
      status: "Signed",
    },
    {
      name: "Priyank Sharma",
      id: "APP12546",
      email: "priyank2254@gmail.com",
      contact: "+91 7869875654",
      uploadedBy: "HR Department",
      uploadDate: "18/01/2026",
      documents: [
        { doc: "Travel Insurance", icon: faCircleCheck },
        { doc: "Motivation", icon: faCircleInfo },
        { doc: "Statement", icon: faCircleCheck },
        { doc: "CV", icon: faCircleInfo },
      ],
      note: "Prepare the intern's arrival",
      status: "Signed",
    },
    {
      name: "Priyank Sharma",
      id: "APP12546",
      email: "priyank2254@gmail.com",
      contact: "+91 7869875654",
      uploadedBy: "HR Department",
      uploadDate: "18/01/2026",
      documents: [
        { doc: "Travel Insurance", icon: faCircleCheck },
        { doc: "Motivation", icon: faCircleInfo },
        { doc: "Statement", icon: faCircleCheck },
        { doc: "CV", icon: faCircleInfo },
      ],
      note: "Prepare the intern's arrival",
      status: "Pending",
    },
    {
      name: "Priyank Sharma",
      id: "APP12546",
      email: "priyank2254@gmail.com",
      contact: "+91 7869875654",
      uploadedBy: "HR Department",
      uploadDate: "18/01/2026",
      documents: [
        { doc: "Travel Insurance", icon: faCircleCheck },
        { doc: "Motivation", icon: faCircleInfo },
        { doc: "Statement", icon: faCircleCheck },
        { doc: "CV", icon: faCircleInfo },
      ],
      note: "Prepare the intern's arrival",
      status: "Signed",
    },
  ];

  return (
    <>
      <section className="Collage_portal_documents">
        <Row>
          <Col lg={12} className="mb-3">
            <Documents_buckets />
          </Col>
        </Row>
        <div className="heading_btn_holder">
          <div className="heading_text_holder">
            <h1>All Documents</h1>
          </div>
          <div className="btn_holder">
            <Blue_btn
              btn_text={
                <>
                  <FontAwesomeIcon icon={faUpload} /> Upload Supporting
                  Documents{" "}
                </>
              }
            />
          </div>
        </div>
        <div className="row g-3">
          {documentCardsData.map((item, index) => (
            <div className=" col-xl-4 col-lg-6 col-md-6 col-sm-12 " key={index}>
              <Internship_Agreement_Card
                name={item.name}
                id={item.id}
                email={item.email}
                contact={item.contact}
                uploadedBy={item.uploadedBy}
                uploadDate={item.uploadDate}
                documents={item.documents}
                note={item.note}
                status={item.status}
                onDownload={() => console.log("Download", item.id)}
                onDelete={() => console.log("Delete", item.id)}
              />
            </div>
          ))}
        </div>
      </section>
    </>
  );
}

export default Collage_portal_documents;
